export default "__VITE_ASSET__DQuJjH6K__"